// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__7Zdc5","loading__circles":"Loading_loading__circles__PGRbt","rotate":"Loading_rotate__OpWKL"};